import {compareAsc, subWeeks} from 'date-fns';
import {match} from 'ts-pattern';

import {Nullish} from 'shared/web';

export function getIsExpiring(postponedUntil: string | Nullish) {
  if (!postponedUntil) {
    return false;
  }

  const result = compareAsc(subWeeks(postponedUntil, 1), new Date());

  return match(result)
    .with(-1, () => true)
    .with(0, () => true)
    .with(1, () => false)
    .otherwise(() => false);
}
